var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1C9.44772 1 9 1.44772 9 2C9 2.55228 9.44772 3 10 3H11.5858L5.29289 9.29289C4.90237 9.68342 4.90237 10.3166 5.29289 10.7071C5.68342 11.0976 6.31658 11.0976 6.70711 10.7071L13 4.41421V6C13 6.55228 13.4477 7 14 7C14.5523 7 15 6.55228 15 6V2C15 1.44772 14.5523 1 14 1H10Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3C1.89543 3 1 3.89543 1 5V13C1 14.1046 1.89543 15 3 15H11C12.1046 15 13 14.1046 13 13V10C13 9.44772 12.5523 9 12 9C11.4477 9 11 9.44772 11 10V13H3V5L6 5C6.55228 5 7 4.55228 7 4C7 3.44772 6.55228 3 6 3H3Z",
    fill: "currentColor"
  })));
}

export default SvgLink;